module.exports = __webpack_public_path__ + "img/72.58ee8019.jpg";